export default __webpack_public_path__ + "static/media/image-girl.a940eb97.png";